var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<form ng-submit=\"$ctrl.submit()\" name=\"form\" autocomplete=\"off\"><div ng-include=\"$ctrl.fieldsetTemplateUrl\"></div><div ng-include=\"$ctrl.actionsTemplateUrl\"></div></form>";
var id1="register-current-acct.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;